module.exports = __webpack_public_path__ + "media/images/screenshots/sell-3f6353fb55b0ee6c4dde3c67961fa815.png";